import CadastroApi from './Services/CadastroApi'

export default {
  CadastroApi,
}
